import { render, staticRenderFns } from "./GruposAcessoBusca.vue?vue&type=template&id=31e16825&scoped=true&"
import script from "./GruposAcessoBusca.vue?vue&type=script&lang=js&"
export * from "./GruposAcessoBusca.vue?vue&type=script&lang=js&"
import style0 from "./GruposAcessoBusca.vue?vue&type=style&index=0&id=31e16825&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e16825",
  null
  
)

export default component.exports